// API base URL configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://test-read-db-and-summarize.onrender.com/api'; 